import { useMemo } from 'react';
import { useOrganizationCareFlowsQuery, usePayersQuery } from '../../../graphQL';
import { canReferCareType } from '../../../utils';
import { useCareTypeConfigContext } from '../../CareTypeConfigContext';
import { useCurrentProvider } from '../../Permissions';

export const useNetworkSearchOptions = (organizationId?: number) => {
  const { data } = usePayersQuery({ fetchPolicy: 'cache-first' });
  const { careTypeOptions } = useCareTypeConfigContext();
  const { appView } = useCurrentProvider();
  const { data: careFlowsData, loading: careTypesLoading } = useOrganizationCareFlowsQuery({
    variables: { organizationId: organizationId ?? 0 },
    skip: !organizationId,
  });

  const payers = useMemo(
    () => data?.payers.map(payer => ({ id: payer.id, label: payer.name })) ?? [],
    [data?.payers]
  );

  const careFlows = careFlowsData?.organization.careFlows;
  const careTypes = useMemo(() => {
    if (!organizationId) {
      return careTypeOptions;
    }
    return careFlows
      ? careTypeOptions.filter(option => canReferCareType(careFlows, appView, option.id))
      : [];
  }, [organizationId, careTypeOptions, careFlows, appView]);

  return { payers, careTypes, careTypesLoading };
};
